import LegalPage from '@/pages/legal/components/LegalPage';
import { politiqueConfidentialiteContent } from '@/mocks/politiqueConfidentialiteContent';

export default function PolitiqueConfidentialite() {
  return <LegalPage content={politiqueConfidentialiteContent} />;
}